import { Breakpoints } from "../group-class/gc-card-setup";

export class ImageCardConfig {
  private static isValidUrl(string) {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  }

  private action: () => {};
  private link: string;
  private imageSize: Breakpoints;
  private _imageSrc: {[key in Breakpoints]: string};

  public get imageSrc(): string {
    return this._imageSrc[this.imageSize];
  }

  public get isClickable(): boolean {
    return !!this.action || ImageCardConfig.isValidUrl(this.link);
  }

  public setImageSrc(imageSrc: {[key in Breakpoints]: string}) {
    this._imageSrc = imageSrc;
  }

  public setImageSize(size: Breakpoints) {
    this.imageSize = size;
  }

  public setAction(action: () => {}) {
    this.action = action;
  }

  public setLink(link: string) {
    this.link = link;
  }

  public onClick() {
    if (this.action) {
      this.action();
      return;
    }
    if (ImageCardConfig.isValidUrl(this.link)) {
      window.open(this.link);
    }
  }
}


// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/image-card-config/image-card-config.ts